import { FC } from "react";

import { ChatIcon, SearchIcon } from "@/assets/icons";
import Tooltip from "@/components/ui/tooltip";

import ChatHistoryList from "./ChatHistoryList";
import type { ChatHistoryEntry } from "./constants";

type Props = {
  title: string;
  chats: ChatHistoryEntry[];
  activeChatId: string | null;
  onNewChat: () => void;
  onSelectChat: (chatId: string) => void;
};

const actionClassName =
  "flex w-full items-center gap-3 rounded-md px-2 py-2 text-sm text-txtBody font-semibold transition-colors hover:bg-teal-50 disabled:cursor-not-allowed disabled:text-txtPlaceholder disabled:hover:bg-transparent [&>svg]:h-5 [&>svg]:w-5 [&>svg]:shrink-0 [&>svg]:fill-dim-gray";

const AgenticAISidebar: FC<Props> = ({
  title,
  chats,
  activeChatId,
  onNewChat,
  onSelectChat
}) => (
  <aside
    aria-label="Chat history"
    className="flex h-full w-[280px] shrink-0 flex-col border-r border-gainsboro bg-white"
  >
    <div className="flex items-center px-4 py-[1.075rem]">
      <h2 className="truncate text-lg font-bold text-txtHeading">{title}</h2>
    </div>

    <div className="flex flex-col gap-1 px-2 py-4">
      <button type="button" onClick={onNewChat} className={actionClassName}>
        <ChatIcon />
        New Chat
      </button>

      <Tooltip
        content="Searching chats is not available yet"
        position="top-center"
      >
        <span className="flex">
          <button type="button" disabled className={actionClassName}>
            <SearchIcon />
            Search
          </button>
        </span>
      </Tooltip>
    </div>

    <ChatHistoryList
      chats={chats}
      activeChatId={activeChatId}
      onSelect={onSelectChat}
    />
  </aside>
);

export default AgenticAISidebar;
